export default __webpack_public_path__ + "static/media/special_offer.e62f28f4.png";